import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getpgeactivityskillThunk = createAsyncThunk("pgeskillsetmanager/getpgeactivityskill", async (params) => {
  const { preferedlanguage, program, subject, clas } = params;
  let response = await api.get("getpgeactivityskill/" + preferedlanguage + "/" + program + "/" + subject + "/" + clas);
  return response.data;
});

export const createpgeskillmasterThunk = createAsyncThunk("pgeskillsetmanager/createpgeactivityskill", async (body) => {
  let response = await api.post("createpgeskill/", body);
  return response.data;
});

export const updatepgeskillmasterThunk = createAsyncThunk("pgeskillsetmanager/updatepgeactivityskill", async (reqbody) => {
  const id = reqbody._id;
  const body = reqbody.body;
  let response = await api.put("updatepgeskillmaster/" + id, body);
  return response.data;
});

export const deletepgeskillmasterThunk = createAsyncThunk("pgeskillsetmanager/deletepgeactivityskill", async (id) => {
  let response = await api.delete("deletetpgeskill/" + id);
  return response.data;
});




